import { AGENT_SSO_LOGIN } from '../../endpoints';
import { JobApplication } from '../../types/jobs';

interface SsoLoginResponse {
  message: string;
  user: JobApplication;
}

const ssoLoginApi = async (
  ssoToken: string,
  options?: Pick<RequestInit, 'signal'>
): Promise<SsoLoginResponse> => {
  try {
    const response = await fetch(AGENT_SSO_LOGIN, {
      method: 'POST',
      body: JSON.stringify({ ssoToken }),
      headers: {
        'Content-Type': 'application/json',
      },
      ...options,
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message);
    }

    return result;
  } catch (error) {
    throw error;
  }
};

export { ssoLoginApi, type SsoLoginResponse };
